import bg1 from './assets/images/anime_bedroom_1780196695443.png';
import bg2 from './assets/images/anime_japan_street_1780196709547.png';
import bg3 from './assets/images/anime_sakura_park_1780196723462.png';
import bg4 from './assets/images/anime_night_street_1780237444668.png';

export const backgrounds = [bg1, bg2, bg3, bg4];
